{/* <html>

<head>
  <meta charset="utf-8" />
  <style>
    .pydocx-caps {
      text-transform: uppercase
    }

    .pydocx-center {
      text-align: center
    }

    .pydocx-comment {
      color: blue
    }

    .pydocx-delete {
      color: red;
      text-decoration: line-through
    }

    .pydocx-hidden {
      visibility: hidden
    }

    .pydocx-insert {
      color: green
    }

    .pydocx-left {
      text-align: left
    }

    .pydocx-list-style-type-cardinalText {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimal {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimalEnclosedCircle {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimalEnclosedFullstop {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimalEnclosedParen {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimalZero {
      list-style-type: decimal-leading-zero
    }

    .pydocx-list-style-type-lowerLetter {
      list-style-type: lower-alpha
    }

    .pydocx-list-style-type-lowerRoman {
      list-style-type: lower-roman
    }

    .pydocx-list-style-type-none {
      list-style-type: none
    }

    .pydocx-list-style-type-ordinalText {
      list-style-type: decimal
    }

    .pydocx-list-style-type-upperLetter {
      list-style-type: upper-alpha
    }

    .pydocx-list-style-type-upperRoman {
      list-style-type: upper-roman
    }

    .pydocx-right {
      text-align: right
    }

    .pydocx-small-caps {
      font-variant: small-caps
    }

    .pydocx-strike {
      text-decoration: line-through
    }

    .pydocx-tab {
      display: inline-block;
      width: 4em
    }

    .pydocx-underline {
      text-decoration: underline
    }

    body {
      margin: 0px auto;
      width: 51.00em
    }
  </style>
</head>

<body> */}
let ESignES = `
  <p>Este Aviso de divulgación y consentimiento de E-Sign ("Aviso") se aplica a todas las comunicaciones, tal como se definen
    a continuación, para los servicios prestados por Barri Money Services, LLC y nuestras afiliadas ("Barri" o "Nosotros").
    En virtud de este Aviso, las comunicaciones que reciba en formato electrónico de nosotros se considerarán "por escrito".</p>
  <p>Al utilizar los servicios electrónicos y en línea de Barri ("Servicios electrónicos"), acepta este Aviso y afirma que tiene
    acceso a los requisitos de hardware y software identificados a continuación. Además, debe revisar y aceptar los términos
    de estos servicios. Si decide no dar su consentimiento a este Aviso o retira su consentimiento, se le restringirá el
    uso de los Servicios electrónicos.</p>
  <p>
    <strong>COMUNICACIONES CUBIERTAS</strong>
  </p>
  <p>Puede incluir, entre otros, divulgaciones y comunicaciones que le proporcionamos con respecto a nuestros servicios, tales
    como: </p>
  <ol type="i" class="pydocx-list-style-type-lowerRoman">
    <li>términos y condiciones, declaración de privacidad o avisos y cualquier cambio al respecto; </li>
    <li> divulgaciones de pago anticipado, recibos de transacciones y confirmaciones; y </li>
    <li> comunicaciones de servicio al cliente (como reclamos de comunicaciones de error) ("Comunicaciones").</li>
  </ol>
  <p>
    <strong>MÉTODOS DE PROPORCIONAR COMUNICACIONES</strong>
  </p>
  <p>Podemos enviarle Comunicaciones por correo electrónico o hacer que estén accesibles en los sitios web de Barri, aplicaciones
    móviles o sitios web móviles (incluso a través de "hipervínculos" proporcionados en línea y en correos electrónicos).
    Las comunicaciones se proporcionarán en línea y se podrán visualizar utilizando el software del navegador o archivos
    PDF. Para transacciones realizadas en Agentes/Tiendas, se pueden proporcionar comunicaciones en las agencias / tiendas.
    En tales casos, podrá imprimir la Comunicación y / o recibirla por correo electrónico.</p>
  <p>
    <strong>REQUISITOS DE HARDWARE Y SOFTWARE</strong>
  </p>
  <p>Para acceder y conservar comunicaciones electrónicas, debe tener:</p>
  <p>• Una dirección de correo electrónico válida;</p>
  <p>• Una computadora, dispositivo móvil, tableta o dispositivo similar con acceso a Internet y un software de navegación y
    software que sea capaz de recibir, acceder, mostrar e imprimir o almacenar las comunicaciones recibidas de nosotros en
    formato electrónico;</p>
  <p>• Suficiente espacio de almacenamiento para guardar Comunicaciones (ya sea que se presente en línea, en correos electrónicos
    o PDF) o la capacidad de imprimir Comunicaciones.</p>
  <p>Podemos solicitar que responda un correo electrónico para demostrar que puede recibir estas Comunicaciones.</p>
  <p>
    <strong>CÓMO RETIRAR SU CONSENTIMIENTO</strong>
  </p>
  <p>Puede retirar su consentimiento para recibir Comunicaciones en virtud de este Aviso, enviándonos un escrito a "Atencion:
    Declaración de consentimiento y aviso de consentimiento, 10777 Westheimer Road, Suite 1040, Houston,TX 77042, USA.", o comunicándose
    con nosotros a través del enlace "Contáctenos" en
    <a href="https://www.barri.com">https://www.barri.com</a> . Su revocación del consentimiento cancelará su acuerdo de recibir Comunicaciones electrónicas
    y, por lo tanto, su capacidad de utilizar nuestros Servicios electrónicos.</p>
  <p>
    <strong>SOLICIT</strong>
    <strong>UD DE</strong>
    <strong> COPIAS DE COMUNICACIONES ELECTRÓNICAS</strong>
  </p>
  <p>Puede solicitar una copia en papel de cualquier Comunicaciones; le enviaremos una copia por correo de los Estados Unidos
    de Norteamerica. Para solicitar una copia en papel, comuníquese con nosotros escribiendo a "Atención: Declaración de
    firmas electrónicas y aviso de consentimiento, 10777 Westheimer Road, Suite 1040, Houston,TX 77042, USA.", o comunicándose con
    nosotros a través del enlace "Contáctenos" en https://
    <a href="http://www.barri.com">www.barri.com</a> .Proporcione su dirección de correo actual para que podamos procesar esta solicitud. Barri puede
    cobrarle una tarifa razonable por este servicio.</p>
  <p>
    <strong>ACTUALIZANDO SU INFORMACIÓN DE CONTACTO</strong>
  </p>
  <p>Es su responsabilidad mantener actualizada su dirección de correo electrónico principal para que Barri pueda comunicarse
    con usted electrónicamente. Usted comprende y acepta que si Barri le envía una Comunicación pero no la recibe porque
    su dirección de correo electrónico principal registrada es incorrecta, desactualizada, bloqueada por su proveedor de
    servicios o usted no puede recibir comunicaciones electrónicas, Barri considerara que le ha proporcionado la Comunicación;
    sin embargo, podemos considerar su cuenta inactiva. Es posible que no pueda realizar transacciones con nuestros Servicios
    en línea hasta que recibamos de usted una dirección de correo electrónico principal válida y operativa.</p>
  <p>Si utiliza un filtro de correo no deseado o software similar que bloquea o cambia el rumbo de los correos electrónicos
    de remitentes que no figuran en su libreta de direcciones de correo electrónico, le recomendamos que agregue Barri a
    su libreta de direcciones de correo electrónico para que pueda recibir comunicaciones por correo electrónico.</p>
  <p>Puede actualizar su dirección de correo electrónico principal u otra información escribiéndonos a "Attn: Declaración de
    firma electrónica y aviso de consentimiento, 10777 Westheimer Road, Suite 1040, Houston,TX 77042, USA.", o poniéndose en contacto
    con nosotros a través del enlace "Contáctenos" en
    <a href="https://www.barri.com">https://www.barri.com</a>
  </p>
  <p>
    <strong>LEY FEDERAL</strong>
  </p>
  <p>Usted reconoce y acepta que su consentimiento para las comunicaciones electrónicas se proporciona en relación con una transacción
    que afecta el comercio interestatal que está sujeto a las Firmas electrónicas federales en la Ley de Comercio Global
    y Nacional, y que usted y los dos tenemos la intención de que la Ley se aplique al máximo en la medida de lo posible
    para validar nuestra capacidad de realizar negocios con usted por medios electrónicos.</p>
  <p>
    <strong>TERMINACIÓN / CAMBIOS</strong>
  </p>
  <p>Nos reservamos el derecho, a nuestro exclusivo criterio, de suspender la prestación de sus Comunicaciones, o de rescindir
    o cambiar los términos y condiciones en los que proporcionamos las Comunicaciones. Le enviaremos un aviso de dicha terminación
    o cambio según lo exija la ley.</p>`
{/* </body>

</html> */}

module.exports = ESignES


// WEBPACK FOOTER //
// ./public/documents/e-signES.js